import type { AIDTColor } from './_typing';

export const yellow: AIDTColor = Object.freeze({
  50: '#',
  100: '#',
  200: '#',
  300: '#',
  400: '#',
  500: '#FBEB97',
  600: '#',
  700: '#',
  800: '#',
  900: '#',
  950: '#',
  0: '#',
} as const);
